/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import './style/premiumFeature.scss';

import {voidFunction, WithBackground} from '@dvrd/dvr-controls';
import React, {MouseEventHandler, PureComponent} from 'react';
import {BolmateButton} from "../controls";
import Image from "../misc/image";

interface Props {
    onProceed: MouseEventHandler;
    active: boolean;
}

export default class PremiumFeature extends PureComponent<Props> {
    render = () => {
        const {active, onProceed} = this.props;
        return (
            <WithBackground active={active} onClose={voidFunction} backgroundClass='premium-background'
                            backgroundColor='transparent'>
                <div className='premium-feature'>
                    <div className='header-container'>
                        <label className='header-title'>Premium Feature</label>
                    </div>
                    <div className='body-container'>
                        <Image name='trial-rocket' className='trial-img'/>
                        {/*<img className='trial-img' src={getImg('trial-rocket')} alt='Bolmate.nl'/>*/}
                        <label className='body-title'>Doorgaan met Bolmate</label>
                        <p className='message-container'>
                            Deze feature is niet beschikbaar zonder abonnement.<br/>Ga naar de instellingen om je
                            abonnement te starten.
                        </p>
                        <BolmateButton onClick={onProceed} label='Ga naar instellingen'/>
                    </div>
                </div>
            </WithBackground>
        )
    }
}